module.exports = __webpack_public_path__ + "static/media/lascalles02_small.c6b2d94a.jpg";